import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    // mode:'history',
    path: '/',
    redirect: '/NotFound'
  },
  {
    name: 'eform',
    component: () => import('./view/eform'),
    meta: {
      title: '主页'
    },
    children: [
      {
        path: '/:countryPath/:brand/EnterOpt/:lang',
        component: () =>
          import('./view/eform/EnterOpt'),
        name: 'EnterOpt',
        meta: {
          title: 'Enter Otp'
        }
      },
      {
        path: '/:countryPath/:brand/EnterNumber/:lang',
        component: () =>
          import('./view/eform/EnterNumber'),
        name: 'EnterNumber',
        meta: {
          title: 'Enter Number'
        }
      },
      {
        path: '/:countryPath/:brand/Registration/:lang',
        component: () =>
          import('./view/eform/Registration'),
        name: 'Registration',
        meta: {
          title: 'Registration'
        }
      },
      {
        path: '/NotFound',
        component: () =>
          import('./view/eform/NotFound'),
        name: 'NotFound',
        meta: {
          title: 'Page not using'
        }
      },
      {
        path: '/:countryPath/QRcodes/:lang',
        component: () =>
          import('./view/eform/QRcodes'),
        name: 'QRcodes',
        meta: {
          title: 'QRcodes'
        }
      },
    ]
  },
  //for third-part binding callback
  {
    path: '/:thirdPart/callback',
    component: () =>
      import('./view/eform/Callback'),
    name: 'Callback',
    meta: {
      title: 'Callback'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ mode: 'hash', routes: routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  if (to.name == 'NotFound' || to.name == "Registration" || to.name == "QRcodes" || to.name == "EnterNumber" || to.name == "EnterOpt" || to.name == 'Callback') {
    next()
  } else {
    next({ path: '/NotFound' })
  }
});

export {
  router
};
